import React, { useState } from "react";
import "./index.scss";
import loginImage from "../../assets/images/loginBg.png";
import { loginClient } from "../../services/auth"; // ✅ import service
import { useClientAuth } from "../../context/ClientAuthContext";
import { useNavigate } from "react-router-dom";
import Popup from "../../components/common/Popup";

export const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const { handleClientLogin } = useClientAuth();
  const navigate = useNavigate();

  const isFormValid =
    formData.email.trim() !== "" && formData.password.trim() !== "";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    setIsLoading(true);
    setError("");

    try {
      console.log("Attempting login with:", formData.email);
      // ✅ use service instead of fetch
      const result = await loginClient(formData.email, formData.password);
      console.log("Login result:", result);

      if (result.success) {
        console.log("Login successful, user:", result.user);
        handleClientLogin(result.user);
        setShowSuccessPopup(true);
      } else {
        console.log("Login failed:", result.msg);
        setError(result.msg || "Email ou mot de passe incorrect");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Erreur de connexion. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="login-page-client">
      <div className="login-container">
        {/* Left - Image */}
        <div className="login-image-section">
          <div className="login-circular-alma">
            <svg width="160" height="160" viewBox="0 0 160 160">
              <defs>
                <path
                  id="almaPath"
                  d="M 80, 80 m -60, 0 a 60,60 0 1,1 120,0 a 60,60 0 1,1 -120,0 "
                />
              </defs>
              <text
                fill="black"
                fontFamily="IvyJournal"
                fontSize="16"
                fontWeight="bold"
                letterSpacing="2">
                <textPath href="#almaPath">
                  A L M A - A L M A - A L M A - A L M A - A L M A - A L M A -
                </textPath>
              </text>
            </svg>
          </div>
          <div className="login-product-image">
            <img
              src={loginImage}
              alt="Woman with Alma Secret product"
              className="login-portrait-image"
            />
          </div>
        </div>

        {/* Right - Form */}
        <div className="login-form-section">
          <div className="login-form-container">
            <div className="login-logo-section">
              <div className="login-brand-logo">Alma Secret.</div>
              <div className="login-brand-subtitle">
                NATURAL & THERMAL COSMETICS
              </div>
            </div>

            <h1 className="login-form-title">CONNECTEZ-VOUS</h1>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-form-group">
                <div className="login-input-wrapper">
                  <span className="login-input-icon">✉</span>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="EMAIL*"
                    required
                  />
                </div>
              </div>

              <div className="login-form-group">
                <div className="login-input-wrapper">
                  <span className="login-input-icon">***</span>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="MOT DE PASSE*"
                    required
                  />
                </div>
              </div>

              {error && <div className="login-error">{error}</div>}

              <button
                type="submit"
                className={`login-button ${isLoading ? "loading" : ""}`}
                disabled={!isFormValid || isLoading}>
                <span className="login-play-icon">▶</span>
                {isLoading ? "CONNEXION EN COURS..." : "COMMENCEZ"}
              </button>

              <div className="login-register-link">
                <span>VOUS N'AVEZ PAS DE COMPTE?</span>
                <a href="/register" className="login-register-text">
                  INSCRIVEZ-VOUS
                </a>
              </div>

              <div className="login-forgot-link">
                <a href="/forgot-password" className="login-forgot-text">
                  MOT DE PASSE OUBLIÉ?
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      <Popup
        isOpen={showSuccessPopup}
        onClose={handleSuccessPopupClose}
        title="Connexion réussie!"
        message="Vous êtes maintenant connecté à votre compte."
        type="success"
        buttonText="Continuer"
        onButtonClick={handleSuccessPopupClose}
      />
    </div>
  );
};
